export const RouteLinks = {
  AUTH: "/auth",
  MAIN: "/",
  MAIN_V2: "/v2",
  SUPPORT: "/support",
  INVITE_COMPLETE: "/invite/complete",
  INVITE_ORGANIZATION_COMPLETE: "/invite/organization/complete",
  INVITE_ORGANIZATION_CONTRACT_COMPLETE: "/invite/organization-contract/complete",
  INVITE_NEW_ORGANIZATION_COMPLETE: "/invite/new_organization/complete",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_CONFIRM: "/user/reset-password/confirm",
  PROTECTED: {
    LIST_EQUIPMENT: "/list-equipment",
    CASES: {
      MAIN: "/cases",
      CASE: "/cases/case",
    },
    SETTINGS: {
      MAIN: "/settings",
      GENERAL: "/settings/general",
      MY_PROFILE: "/settings/profile",
      COMPANY_DETAILS: "/settings/company-details",
      TEAM: "/settings/team",
      EMAIL_SENDER: "/settings/email-sender",
    },
    EXTENSIONS: {
      SHARED_DRIVE: "/extensions/shared-drive",
    },
    CONTRACTS_ROUTES: {
      MAIN: "/contracts",
      CONTRACT: "/contracts/contract",
      NEW: "/contracts/new",
      INVITATION: "/contracts/invitation",
      DOC_GEN: "/contracts/doc-gen",
    },
    DOWNLOADS: "/downloads",
    DOWNLOAD_ROUTES: {
      MAIN: "/downloads",
      FILE: "/downloads/file",
      ADD_FILE: "/downloads/add-file",
    },
    PRODUCTS: "/products",
    CONTRACTORS: {
      LIST: "/contractors",
      NEW: "/contractors/new",
    },
  },
};
